module.exports = __webpack_public_path__ + "static/media/weather.fc77876e.png";